/**
 * DEV-959. Память навигации по спискам (клиенты/сделки/агенты): запоминаем последний
 * URL списка с фильтрами и позицию прокрутки, чтобы точки возврата (хлебная крошка,
 * кнопки «Назад») вели обратно с сохранённым состоянием.
 *
 * Живёт только в памяти (без persist) — при полной перезагрузке страницы список сам
 * получит фильтры из своего URL; «запомненный URL» нужен точкам возврата внутри одной
 * SPA-сессии. Лежит на верхнем уровне stores/ (как userDirectory), т.к. используется
 * тремя разными фичами сразу: clients, deals, agents.
 */
import { ref } from 'vue'
import { defineStore } from 'pinia'

export type ListSection = 'clients' | 'deals' | 'agents' | 'properties' | 'videomeetings'

interface ListNavState {
  fullPath: string // route.fullPath списка на момент последнего изменения фильтров/страницы
  scrollTop: number
}

export const useListNavigationStore = defineStore('listNavigation', () => {
  const state = ref<Partial<Record<ListSection, ListNavState>>>({})

  const rememberUrl = (section: ListSection, fullPath: string) => {
    state.value[section] = { ...(state.value[section] ?? { scrollTop: 0 }), fullPath }
  }

  const rememberScroll = (section: ListSection, scrollTop: number) => {
    const entry = state.value[section]
    if (entry) entry.scrollTop = scrollTop
  }

  const urlFor = (section: ListSection): string | undefined => state.value[section]?.fullPath

  const scrollFor = (section: ListSection): number => state.value[section]?.scrollTop ?? 0

  return { rememberUrl, rememberScroll, urlFor, scrollFor }
})
